<template>
  <div id="app">
    <el-container>

      <el-container class="mainContainer">
        <el-main style="height: calc(100vh);overflow-y: auto;">
          <advice :hideBreadcrumb='true' />
        </el-main>
      </el-container>
    </el-container>

  </div>
</template>

<script>

import axios from 'axios'
import advice from './app/service.vue'
export default {
  name: 'App',

  data () {
    return {
      activeMenu: '/',
      curLoginDialog: false,
      type: 'login',
      imgCaptcha: {},
      payDialogVisible: false,
      payData: {},
      fileType: '',
      reportType: '',
      accountForm: {
        account: '',
        password: '',
        imgCaptcha: '',
        agreeChecked: true
      },
      accountRules: {
        account: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
        ]
      },
      regForm: {
        mobile: '',
        password: '',
        rePassword: '',
        agreeChecked: true,
        companyName: '',
        job: '',
        name: '',
        imageCaptcha: '',
        smsCaptcha: ''
      },
      regRules: {
        mobile: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ]
      },
      changeType (t) {
        this.type = t
      },
      wechatUrl: ''

    }
  },
  components: {
    advice
  },
  mounted: function () {
    // let token = this.$route.query.token
    // let path = this.$route.query.path
    // let code = this.$route.query.code
    // let tenant = this.$route.query.tenant
    // this.activeMenu = path
    // let _this = this
    // console.log('code:' + code)
    // console.log('token:' + token)
    // console.log('tenant:' + tenant)
    // if (token && code) { // csmar 等代理商登录
    //   axios.get('/api/web/auth/logout').then(resp => {
    //     setTimeout(() => {
    //       axios.post('/api/web/proxy/login', this.$route.query).then(resp => {
    //         _this.$router.push({ 'path': '/' })
    //         _this.$store.commit('toFreshUserPrice')
    //         _this.$store.commit('refreshUserInfo')
    //         _this.loadWechatUrl(path)
    //       })
    //     }, 500)
    //   })
    // } else {
    //   this.loadWechatUrl(path)
    // }
  },
  methods: {
    loadWechatUrl (path) {
      // let _this = this
      // axios.get('/api/web/wechat/url?state=' + path).then(resp => {
      //   _this.wechatUrl = resp.data
      // })
    },
    toReg () {
      axios.post('/api/web/auth/regUser', this.regForm).then(resp => {
        localStorage.setItem('userinfo', JSON.stringify(resp.data))
        if (window.parent) {
          window.open(window.parent.location.href, '_top')
        }
        window.location.reload()
      })
    },
    loginByMobile () {
      let _this = this
      this.$refs['accoutRuleForm'].validate((valid) => {
        if (valid) {
          _this.accountForm.imgCaptchaKey = _this.imgCaptcha.key
          axios.post('/api/web/csmar/loginByAccount', _this.accountForm).then(resp => {
            localStorage.setItem('userinfo', JSON.stringify(resp.data))
            if (window.parent) {
              window.open(window.parent.location.href, '_top')
            }
            window.location.reload()
          })
        } else {
          return false
        }
      })
    },
    checkMobile () {
      if (this.regForm.mobile) {
        axios.post('/api/web/auth/checkMobile', { 'mobile': this.regForm.mobile })
      }
    },
    toSendSms () {
      axios.post('/api/web/auth/sendSmsCaptcha', { 'mobile': this.regForm.mobile, 'key': this.imgCaptcha.key, 'imgCaptcha': this.regForm.imageCaptcha })
    },
    toGetImgCaptcha () {
      let _this = this
      axios.get('/api/web/auth/captchaImg?' + Math.random()).then(resp => {
        _this.imgCaptcha = resp.data
      })
    }
  },
  computed: {

  },
  watch: {

    loginDialog: function () {
      if (this.loginDialog) {
        this.curLoginDialog = true
        this.toGetImgCaptcha()
      }
    }

  }

}
</script>
<style lang="less" >
@import "./assets/css/index.less";
.imgCaptchaContainer .el-input-group__append {
  background-color: white;
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  min-height: 100vh;
}
html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  min-width: 1300px;
}

.el-header .el-dropdown {
  color: white;
}

.el-aside .el-menu-item:hover {
  color: #666666;
  background-color: #e8eaed;
}
.el-main {
  background-color: #f5f7fa;
}
.mainContainer {
  min-height: calc(100vh - 60px);
}
</style>



// WEBPACK FOOTER //
// src/Advice.vue